import React, { useState, useEffect } from "react";
import EditSupplierForm from "./SupplierManagentForm";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddStorageForm from "./AddSupplier";
import { store } from "../../../../redux-store/store";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "25%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "name", label: "Name" },
  { id: "contact_info", label: "Contact Info" },
  { id: "payment_terms", label: "Payment Terms" },
  { id: "createdAt", label: "Created At" },
  { id: "rating", label: "Rating" },
  { id: "actions", label: "Actions", disableSorting: true },
];

export function Suppliers({ suppliers, AddSupplier }) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(suppliers, headCells, filterFn);
  useEffect(() => {
    store.dispatch({ type: "LOAD_SUPPLIERS" });
    return () => {};
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.name.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const addOrEdit = (Supplier, resetForm) => {
    if (Supplier.id === 0) AddSupplier(Supplier);
    else var data = { ...Supplier };
    store.dispatch({ type: "UPDATE_SUPPLIER", payload: data });
    resetForm();
    // setRecordForEdit(null);
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const addSupplier = (supplier, resetForm) => {
    store.dispatch({ type: "ADD_SUPPLIER", payload: supplier });
    resetForm();
    setRecordForEdit(null);
    setAddOpenPopup(false);
    setOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const onDelete = (id) => {
    store.dispatch({ type: "DELETE_SUPPLIER", payload: id });
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };

  return (
    <>
      <div
        className="container"
        style={{ paddingTop: "40px", marginTop: "-5rem" }}
      >
        <div>
          <Column flexGrow={1}>
            <ToastContainer />
            <div className="mt-4 pr-3">
              <Controls.Input
                placeholder="Search Suppliers by Supplier Name"
                className={classes.searchInput}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={handleSearch}
              />
            </div>
            <Paper className={classes.pageContent}>
              <h4>
                <strong>Supplier Management</strong>
              </h4>
              <Toolbar>
                <Controls.Button
                  text="Add New"
                  variant="outlined"
                  startIcon={<AddIcon />}
                  className={classes.newButton}
                  onClick={() => {
                    setAddOpenPopup(true);
                    setRecordForEdit(null);
                  }}
                />
              </Toolbar>
              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.contact_info}</TableCell>
                      <TableCell>{item.payment_terms}</TableCell>
                      <TableCell>
                        {new Date(item.createdAt).toDateString()}
                      </TableCell>
                      <TableCell>{item.rating}</TableCell>
                      <TableCell>
                        <Controls.ActionButton
                          color="primary"
                          onClick={() => {
                            openInPopup(item);
                          }}
                        >
                          <EditOutlinedIcon fontSize="small" />
                        </Controls.ActionButton>
                        <Controls.ActionButton
                          color="secondary"
                          onClick={() => {
                            setConfirmDialog({
                              isOpen: true,
                              title: "Are you sure to delete this record?",
                              subTitle: "You can't undo this operation",
                              onConfirm: () => {
                                onDelete(item.id);
                              },
                            });
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </Controls.ActionButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </Paper>
            <Popup
              title="Edit Supplier Form"
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
            >
              <EditSupplierForm
                recordForEdit={recordForEdit}
                addOrEdit={addOrEdit}
              />
            </Popup>

            <Popup
              title="Add New Supplier"
              openPopup={addOpenPopup}
              setOpenPopup={setAddOpenPopup}
            >
              <AddStorageForm
                recordForEdit={recordForEdit}
                addSupplier={addSupplier}
              />
            </Popup>
            <Notification notify={notify} setNotify={setNotify} />
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </Column>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    user: state.userReducer.user,
    suppliers: state.supplierReducer.suppliers,
  };
}

const mapDispatchToProps = (dispatch) => ({
  UpdateSupplier(payload) {
    dispatch({ type: "UPDATE_SUPPLIER", payload });
  },

  LoadSuppliers(payload) {
    dispatch({ type: "LOAD_SUPPLIERS", payload });
  },
  AddSupplier(payload) {
    dispatch({ type: "ADD_SUPPLIER", payload });
  },

  DeleteSupplier(payload) {
    dispatch({ type: "DELETE_SUPPLIER", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Suppliers);
